var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#1DB954"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.616 15.013c-.281 0-.513-.094-.693-.281-.967-.781-2.209-1.318-3.725-1.612a8.34 8.34 0 0 0-1.764-.19c-.67 0-1.311.073-1.921.219a8.985 8.985 0 0 0-1.764.55c-.293.129-.464.185-.513.185-.281 0-.507-.232-.507-.513 0-.219.129-.408.342-.478 1.123-.46 2.245-.69 3.363-.69.67 0 1.334.075 1.998.225 1.764.342 3.323.986 4.676 1.932a.513.513 0 0 1 .195.403c0 .281-.232.513-.513.513h-.174zm.952-2.246c-.321 0-.586-.107-.794-.321-1.193-.928-2.598-1.571-4.216-1.932a10.42 10.42 0 0 0-2.113-.225c-.803 0-1.578.092-2.324.275-.745.183-1.467.455-2.166.816a.678.678 0 0 1-.321.092c-.367 0-.646-.279-.646-.646 0-.279.138-.509.414-.601 1.423-.586 2.846-.879 4.268-.879.803 0 1.605.092 2.408.275 1.834.385 3.513 1.101 5.036 2.148.275.183.413.459.413.733 0 .367-.279.646-.646.646h-.313zm1.193-2.754c-.381 0-.7-.131-.958-.394-1.414-1.1-3.057-1.865-4.928-2.296a12.34 12.34 0 0 0-2.507-.269c-.953 0-1.877.11-2.772.331a11.907 11.907 0 0 0-2.557.96.747.747 0 0 1-.381.11c-.437 0-.775-.331-.775-.775 0-.331.165-.606.496-.719 1.689-.7 3.378-1.05 5.067-1.05.953 0 1.906.11 2.858.331 2.177.496 4.161 1.414 5.952 2.754.331.221.496.552.496.883 0 .437-.331.775-.775.775h-.216z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.6db5ed15cfe83aeb0c216bea246817db.svg";
export { ForwardRef as ReactComponent };